import { createContext, useContext } from "react";

export const AdminLayoutContext = createContext({
  openMobileMenu: () => {},
});

export function useAdminLayout() {
  return useContext(AdminLayoutContext);
}
